import React, { useState } from 'react'
import { isNDISVerification } from '../../../_requests'
import { toast } from 'react-toastify'
import SettingsTab from './SettingsTab'
import ActivityTab from './ActivityTab'
import { KTCard, KTCardBody } from '../../../../../../../_metronic/helpers'

interface Props {
  userDetails: any
  saveUser: (u: any) => void
  formatError: (err: any) => string
}

const UserOverviewTabs: React.FC<Props> = ({ userDetails, saveUser }) => {
  const [, setLoading] = useState(false)

  // Handle immediate update when NDIS Verification select or checkbox changes
  const handleNDISChange = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const isCheckbox = (e.target as HTMLInputElement).type === 'checkbox'
    const value = isCheckbox ? ((e.target as HTMLInputElement).checked ? '1' : '0') : (e.target as HTMLSelectElement).value
    setLoading(true)
    try {
      const response = await isNDISVerification({ is_ndis_verified: value === '1', ndis_number: userDetails?.ndis_number || '' })
      setLoading(false)
      toast.success(response?.message || 'NDIS status updated successfully.')
      // keep stored value as '1' or '0' for consistency with other parts of the component
      userDetails.is_ndis_verified = response?.responseObject?.is_ndis_verified === true ? '1' : '0'
    } catch (err: any) {
      setLoading(false)
      const msg = err?.response?.data?.message || err?.message || 'Failed to assign role'
      toast.error(msg)
    }
  }

  return (
    <>
      <div className='mb-9' id='kt_user_view_overview_tabs'>
        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold gap-4' role='tablist'>
          <li className='nav-item' role='presentation'>
            <button className='nav-link text-dark active font-15 m-0 px-6' data-bs-toggle='tab' data-bs-target='#tab_profile' type='button' role='tab'>Profile</button>
          </li>
          {/* <li className='nav-item' role='presentation'>
            <button className='nav-link text-dark font-15 m-0 px-6' data-bs-toggle='tab' data-bs-target='#tab_settings' type='button' role='tab'>Settings</button>
          </li>
          <li className='nav-item' role='presentation'>
            <button className='nav-link text-dark font-15 m-0 px-6' data-bs-toggle='tab' data-bs-target='#tab_activity' type='button' role='tab'>Activity Log's</button>
          </li> */}
        </ul>
      </div>

      <div className='tab-content mt-5' id='kt_user_view_overview_tabs_content'>
        {/* Profile view (read-only) */}
        <div className='tab-pane fade show active' id='tab_profile' role='tabpanel'>
          <div className='row g-5'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-1'>
              <KTCard>
                <div className='card-header px-5'>
                  <h3 className='card-title'>About</h3>
                </div>
                <KTCardBody className='p-5'>
                  <div className='table-responsive'>
                    <table className='table table-striped nowrap'>
                      <tbody>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>First Name:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.first_name || '-'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Last Name:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.last_name || '-'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Email:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon'>{userDetails?.user?.email || '-'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Mobile Number:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.phone || '-'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Mobile Verified:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.is_mobile_verified === 1 ? 'Yes' : 'No'}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Email Verified:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.is_email_verified === 1 ? 'Yes' : 'No'}</span>
                          </td>
                        </tr>
                        {(userDetails?.user?.user_type === 'participant' || userDetails?.user?.user_type === 'support_coordinator_lac') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Gender:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.gender || '-'}</span>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>
                            <span className='fs-6 fw-bold text-dark'>Approve Status:</span>
                          </td>
                          <td>
                            <span className='text-settings-icon text-capitalize'>{userDetails?.user?.approval_status || '-'}</span>
                          </td>
                        </tr>
                        {(userDetails?.user?.user_type === 'nurse') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Nurse Type:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.sub_type || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'participant') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Relationship Status:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.relationship_status || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'participant' || userDetails?.user?.user_type === 'support_coordinator_lac') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Year of Birth:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.year_of_birth || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(
                          userDetails?.user?.user_type === 'participant' ||
                          userDetails?.user?.user_type === 'support_worker' ||
                          userDetails?.user?.user_type === 'nurse' ||
                          userDetails?.user?.user_type === 'ndis_participant' ||
                          userDetails?.user?.user_type === 'service_provider' ||
                          userDetails?.user?.user_type === 'support_coordinator_lac' ||
                          userDetails?.user?.user_type === 'allied_health' ||
                          userDetails?.user?.user_type === 'ndis_business'
                        ) && (
                            <tr>
                              <td>
                                <span className='fs-6 fw-bold text-dark'>
                                  {
                                    userDetails?.user?.user_type === 'service_provider' ||
                                      userDetails?.user?.user_type === 'allied_health' ||
                                      userDetails?.user?.user_type === 'ndis_business' ? 'NDIS Registration ID' : 'NDIS Number'}:
                                </span>
                              </td>
                              <td>
                                <span className='text-settings-icon text-capitalize'>{userDetails?.user?.ndis_number || '-'}</span>
                              </td>
                            </tr>
                          )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>ABN Number:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.abn_number || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Service Provider Number:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.service_provider_number || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Business Name:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.business_name || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Business Sector:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.business_sector_name || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Business Type:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.business_type_name || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Facebook URL:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.facebook_url || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Instagram URL:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.instagram_url || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'service_provider' || userDetails?.user?.user_type === 'allied_health' || userDetails?.user?.user_type === 'ndis_business') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Linkedin URL:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>{userDetails?.profile_details?.linkedin_url || '-'}</span>
                            </td>
                          </tr>
                        )}
                        {(
                          userDetails?.user?.user_type === 'participant' ||
                          userDetails?.user?.user_type === 'support_worker' ||
                          userDetails?.user?.user_type === 'nurse' ||
                          userDetails?.user?.user_type === 'support_coordinator_lac'
                        ) && (
                            <tr>
                              <td>
                                <span className='fs-6 fw-bold text-dark'>Interests:</span>
                              </td>
                              <td>
                                <span className='text-settings-icon text-capitalize'>
                                  {userDetails?.user?.interests?.length
                                    ? userDetails.user.interests.join(', ')
                                    : '-'}
                                </span>
                              </td>
                            </tr>
                          )}
                        {(userDetails?.user?.user_type === 'support_coordinator_lac') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Role Type:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>
                                {userDetails?.profile_details?.role_type === 'support_coordinator' ? 'Support Coordinator' : 'LAC'}
                              </span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'support_coordinator_lac') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Working As:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>
                                {userDetails?.profile_details?.working_as || '-'}
                              </span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'support_coordinator_lac' && userDetails?.profile_details?.working_as === 'organisation') && (
                          <>
                            <tr>
                              <td>
                                <span className='fs-6 fw-bold text-dark'>Organisation Name:</span>
                              </td>
                              <td>
                                <span className='text-settings-icon text-capitalize'>
                                  {userDetails?.profile_details?.organisation_name || '-'}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span className='fs-6 fw-bold text-dark'>Organisation Details:</span>
                              </td>
                              <td>
                                <span className='text-settings-icon text-capitalize'>
                                  {userDetails?.profile_details?.organisation_details || '-'}
                                </span>
                              </td>
                            </tr>
                          </>
                        )}
                        {(userDetails?.user?.user_type === 'support_worker' || userDetails?.user?.user_type === 'nurse') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Resume:</span>
                            </td>
                            <td>
                              {/* <a href={userDetails?.profile_details?.resume_file_url} className='text-primary fw-semibold text-decoration-underline' target='_blank'> */}
                                View
                              {/* </a> */}
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'support_worker' || userDetails?.user?.user_type === 'nurse') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Certifications:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>
                                {userDetails?.certifications?.length
                                  ? userDetails.certifications
                                    .map(item => item.certification_name)
                                    .join(', ')
                                  : '-'}
                              </span>
                            </td>
                          </tr>
                        )}
                        {(userDetails?.user?.user_type === 'support_worker' || userDetails?.user?.user_type === 'nurse') && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Currently Employed:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>
                                {userDetails?.profile_details?.currently_employed === '1' ? 'Yes' : 'No'}
                              </span>
                            </td>
                          </tr>
                        )}
                        {(
                          userDetails?.user?.user_type === 'support_worker' ||
                          userDetails?.user?.user_type === 'nurse' ||
                          userDetails?.user?.user_type === 'service_provider' ||
                          userDetails?.user?.user_type === 'ndis_business'
                        ) && (
                            <tr className='align-middle'>
                              <td>
                                <span className='fs-6 fw-bold text-dark'>Locations:</span>
                              </td>
                              <td>
                                {userDetails?.locations?.length ? (
                                  <ul className="mb-0 ps-3">
                                    {userDetails.locations.map((item, index) => (
                                      <li key={index} className="text-settings-icon text-capitalize">
                                        {item.location_name} ({item.service_radius_km} KM Radius)
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className='text-settings-icon'>-</span>
                                )}
                              </td>
                            </tr>
                          )}
                        {(userDetails?.user?.user_type === 'support_coordinator_lac') && (
                          <tr className='align-middle'>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Service Areas:</span>
                            </td>
                            <td>
                              {userDetails?.service_areas?.length ? (
                                <ul className="mb-0 ps-3">
                                  {userDetails.service_areas.map((item, index) => (
                                    <li key={index} className="text-settings-icon text-capitalize">
                                      {item.postcode} - {item.suburb}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <span className='text-settings-icon'>-</span>
                              )}
                            </td>
                          </tr>
                        )}
                        {(
                          userDetails?.user?.user_type === 'service_provider' || 
                          userDetails?.user?.user_type === 'allied_health' || 
                          userDetails?.user?.user_type === 'ndis_business'
                        ) && (
                          <tr>
                            <td>
                              <span className='fs-6 fw-bold text-dark'>Service You Provided:</span>
                            </td>
                            <td>
                              <span className='text-settings-icon text-capitalize'>
                                {userDetails?.user?.services?.length
                                  ? userDetails.user.services.join(', ')
                                  : '-'}
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </KTCardBody>
              </KTCard>
            </div>

            <div className='col-lg-4 col-md-6 col-sm-6 col-xs-12 col-12'>
              {userDetails.role === 'ndis_participant' && (
                <KTCard>
                  <KTCardBody className='p-5'>
                    <div className='d-flex align-items-center justify-content-between gap-3'>
                      <h6 className='m-0'>NDIS Verification:</h6>
                      <div className='form-check form-switch'>
                        <input className='form-check-input' type='checkbox' id='is_ndis_verified' checked={String(userDetails?.is_ndis_verified) === '1'} onChange={handleNDISChange} />
                        <label className='form-check-label' htmlFor='is_ndis_verified'></label>
                      </div>
                    </div>
                  </KTCardBody>
                </KTCard>
              )}
            </div>

          </div>
        </div>

        {/* Code for settings tab */}
        <div className='tab-pane fade' id='tab_settings' role='tabpanel'>
          <SettingsTab />
        </div>

        {/* Code for activity tab */}
        <div className='tab-pane fade' id='tab_activity' role='tabpanel'>
          <ActivityTab />
        </div>
      </div>
    </>
  )
}

export default UserOverviewTabs
